module.exports = __webpack_public_path__ + "media/images/landing__bg--phone-3d6610a70fd43494ab66274dc1e824ef.jpg";